/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('dialog_editSchichtCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', function ($rootScope, $scope, $http, NetworkService, MainService) {

        $(document).ready(function () {
            $('#editSchichtStart').bootstrapMaterialDatePicker(
                    {format: 'YYYY-MM-DD HH:mm:ss'}
            );
            $('#editSchichtEnde').bootstrapMaterialDatePicker(
                    {format: 'YYYY-MM-DD HH:mm:ss'}
            );
        })

        $scope.posOnSchichtEdited = false;
        $scope.fieldInfiniteShift = {visible: false}

        $rootScope.$on("render_dialog_editSchichtCtrl", function () {
            $scope.schicht = MainService.getDialogData('dialog_editSchichtCtrl')
            if ($scope.schicht.menge == -1)
            {
                $scope.fieldInfiniteShift.visible = true;
            }
            console.log($scope.schicht)

        })

        $scope.setInfinite = function ()
        {
            $scope.fieldInfiniteShift.visible = true;
            $scope.schicht.menge = -1;
            $scope.posOnSchichtEdited = true
        }
        $scope.setCount = function ()
        {
            $scope.fieldInfiniteShift.visible = false;
        }
        $scope.countChanged = function ()
        {
            $scope.posOnSchichtEdited = true
            var participants = Object.keys($scope.schicht.mitarbeiter).length

            if ($scope.schicht.menge < participants)
            {
                $scope.warning = "Anzahl ist geringer als registrierte Mitarbeiter"
            } else
            {
                $scope.warning = "";
            }
        }
        $scope.deleteSchicht = function ()
        {
            NetworkService.removeSchicht($scope.schicht, function (data) {

            })
        }
        $scope.updateSchicht = function ()
        {
            $scope.schicht.posOnSchichtEdited = $scope.posOnSchichtEdited;
            $scope.schicht.event_id = MainService.getEventData().event_id
            NetworkService.updateSchicht($scope.schicht, function (data) {
                $rootScope.$emit("repaint")
            });
        }

    }])